export default {
  NODE_ENV: 'production',
  ENDPOINTS: {
    NEST_BACKEND: 'https://api.accuseller.com',
    CAT4MRO_WS: 'wss://backend.cat4mro.com/v1/graphql',
    CAT4MRO_HTTP: 'https://backend.cat4mro.com/v1/graphql',
    CAT4MRO_SECRET: 'YcB59Wr5wvShxFahGLaRHuwe6TXacJzDkAfEpQ4G',
    CAT4MRO_APIHTTP: 'https://mrocatalogupload.azurewebsites.net',
    CAT4MRO_SITE: 'https://portal.cat4mro.com',
    HOOK_API: 'https://hook.ulinksolution.com',
    AZURE_BLOB_UPLOADS: '',
    BLOB_CATEGORY_UPLOADS: 'excel-category-uploads',
    CHATBOT_BACKEND: 'https://chatbot.procure4mro.com',
    CHATBOT_AUTH_USERNAME: 'prod_apiuser_chatbot',
    CHATBOT_AUTH_PASSWORD: 'Lm9@Tx4$Np8&Ks6vR7!qZ2#'
  },
  HUBSPOT: {
    ENABLED: 'true',
    API: 'https://api.hsforms.com/submissions/v3/integration/submit/6644585/a0a9ae42-42e0-4568-85cd-4f86789db0da',
    ACCESS_TOKEN: 'pat-na1-f081d313-d0a4-4831-8d40-b8307f833e4a'
  },
  IDENTITY: {
    AUTHORITY: 'https://sts.ulinksolution.com',
    REDIRECT_URI: 'https://portal-admin.cat4mro.com/static/callback.html',
    SILENT_REDIRECT_URI: 'https://portal-admin.cat4mro.com/static/silent-renew.html',
    POST_LOGOUT_REDIRECT_URI: 'https://portal-admin.cat4mro.com'
  }
}



// WEBPACK FOOTER //
// ./src/config/env.production.js